
import { Component, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

/**
 * 補足、詳細、その他汎用系のボタン
 */
@Component({
  components: {
    ButtonBase,
  },
})
export default class ButtonOptional extends Vue {
  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
